import {draftStepGlobalState} from 'analysis-tool/right-sidebar/components/useMaybeDraftStep';
import {
  AnalysisRightSidebarItem,
  AnalysisRightSidebarItemType,
} from 'analysis-tool/right-sidebar/RightSidebarTypes';
import makeUseGlobalClientState from 'ui-library/hooks/global-client-state/makeUseGlobalClientState';

/**
 * @package
 */
export const selectedRightSidebarItemGlobalState = makeUseGlobalClientState<AnalysisRightSidebarItem | null>(
  null
);

export default function useRightSidebarItem(clientStateId: string): {
  selectedRightSidebarItem: AnalysisRightSidebarItem | null;
  setSelectedRightSidebarItem: (item: AnalysisRightSidebarItem | null) => void;
  clearRightSidebarItem: () => void;
} {
  const [selectedRightSidebarItem, setSelectedRightSidebarItem] =
    selectedRightSidebarItemGlobalState.useGlobalClientState(clientStateId);

  return {
    selectedRightSidebarItem,
    setSelectedRightSidebarItem,
    clearRightSidebarItem: () => {
      if (
        selectedRightSidebarItem &&
        selectedRightSidebarItem.type === AnalysisRightSidebarItemType.EDIT_VIEW
      ) {
        draftStepGlobalState.deleteState(selectedRightSidebarItem.viewReference.stepId);
      }
      setSelectedRightSidebarItem(null);
    },
  };
}
